import styled from 'styled-components';
import { SIZE } from '../../common/sizes';
import { ButtonAction } from 'common/baseComponents';
import { DEFAULT_FONT_FAMILY, BUTTON_ACTION_HEIGHT } from 'common/constants';

export interface TCButtonProps {
    backgroudColor?: string
    disabled?: boolean
}

export const ButtonActionBase = styled(ButtonAction)`
    display:flex;
    justify-content: center;
    align-items: center;
    flex:1;
    // padding: 0 ${SIZE.ONE}px;
`

export const BUTTON_PRIMARY = styled(ButtonActionBase)`
    
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    color: #FFF;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    padding: 0 ${SIZE.ONE}px;
    height: ${BUTTON_ACTION_HEIGHT};
    flex-flow: row;
    border: solid 1px ${(props: TCButtonProps) => props.backgroudColor ? props.backgroudColor : '#4da0ff'};
    background: ${(props: TCButtonProps) => props.backgroudColor ? props.backgroudColor : '#4da0ff'};
    transition: all 0.25s;
    border-radius: 4px;
    &:hover {
        background: ${(props: TCButtonProps) => props.backgroudColor ? props.backgroudColor : '#4da0ff'};
        opacity: 0.8;
        cursor: pointer;
    };
    &:disabled {
        border: solid 1px #c4c4c4;
        background: #c4c4c4;
        color: #FFF;
        cursor: auto;
        box-shadow: none;
        transform: scale(1);
    };
    -webkit-box-shadow: 0 3px 1px -2px transparent, 0 3px 2px 0 rgb(0 0 0 / 9%), 0 1px 5px 0 rgb(0 0 0 / 5%);
    box-shadow: 0 3px 1px -2px transparent, 0 3px 2px 0 rgb(0 0 0 / 9%), 0 1px 5px 0 rgb(0 0 0 / 5%);
`
export const BUTTON_SECONDARY = styled(ButtonActionBase)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    color: #4da0ff;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    padding: 0 ${SIZE.ONE}px;
    height: ${BUTTON_ACTION_HEIGHT};
    flex-flow: row;
    border: solid 1px ${(props: TCButtonProps) => props.backgroudColor ? props.backgroudColor : '#4da0ff'};
    background: ${(props: TCButtonProps) => props.backgroudColor ? props.backgroudColor : '#FFF'};
    transition: all 0.25s;
    border-radius: 4px;
    &:hover {
        background: ${(props: TCButtonProps) => props.backgroudColor ? props.backgroudColor : '#4da0ff55'};
        cursor: pointer;
    };
    &:disabled {
        border: solid 1px #e6e7eb;
        background: #e6e7eb;
        color: #b1b2b5;
        cursor: auto;
        box-shadow: none;
        transform: scale(1);
    };
`
export const BUTTON_THIRDARY = styled(ButtonActionBase)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    color: #373f53;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    padding: 0 ${SIZE.ONE}px;
    height: ${BUTTON_ACTION_HEIGHT};
    flex-flow: row;
    transition: all 0.25s;
    border: solid 1px ${(props: TCButtonProps) => props.backgroudColor ? props.backgroudColor : 'none'};
    background: ${(props: TCButtonProps) => props.backgroudColor ? props.backgroudColor : 'none'};
    border-radius: 1px;
    border-radius: 4px;
    &:hover {
        color: #FFF;
        background: #4da0ff;
        cursor: pointer;
        border: solid 1px #4da0ff;
        box-shadow: 1px 1px 8px 5px #e0e0e0;
        transform: scale(1.04);
    };
    &:disabled {
        border: solid 1px #e6e7eb;
        background: #e6e7eb;
        color: #b1b2b5;
        cursor: auto;
        box-shadow: none;
        transform: scale(1);
    };
`

export const BUTTON_DESTRUCTIVE = styled(BUTTON_THIRDARY)`
    background: ${(props: TCButtonProps) => props.backgroudColor ? props.backgroudColor : ''};
    &:hover {
        color: #FFF;
        background: ${(props: TCButtonProps) => props.backgroudColor ? props.backgroudColor : '#fd583e'};
        border-color: ${(props: TCButtonProps) => props.backgroudColor ? props.backgroudColor : '#fd583e'};
        cursor: pointer;
    };
    &:disabled {
        border: solid 1px #e6e7eb;
        background: #e6e7eb;
        color: #b1b2b5;
        cursor: auto;
        box-shadow: none;
        transform: scale(1);
        
    };
`

export interface ButtonLadingContainerProps {
    width?: number
    background?: string
    borderColor?: string
}
export const ButtonLadingContainer = styled.div`
    display: flex;
    font-size: 14px;
    color: #FFF;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    justify-content: center;
    width: ${(props: ButtonLadingContainerProps) => props.width ? `${props.width}px` : `${SIZE.FIVE}px`};
    min-width: ${SIZE.TWELVE}px;
    height: ${BUTTON_ACTION_HEIGHT};
    border-radius: 4px;
    flex-flow: row;
    border: ${(props: ButtonLadingContainerProps) => props.borderColor ? `solid 1px ${props.borderColor}` : `solid 1px #4da0ff`};
    background: ${(props: ButtonLadingContainerProps) => props.background ? `${props.background}` : `#4da0ff`};
    transition: all 0.25s;
    align-items: center;
`

export const BUTTON_LISMA = styled(ButtonActionBase)`
    display: 'auto';
    font-family: ${DEFAULT_FONT_FAMILY};
    cursor: ${(props: TCButtonProps) => (props.disabled ? 'none' : 'pointer')};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    text-align: left;
    color: ${(props: TCButtonProps) => (props.disabled?'#cccccc':(props.backgroudColor ?? '#4da0ff'))};
    border: solid 1px transparent;
    border-radius:5px;
    padding: 10px 6px 10px 6px;
    background: none;
    &:hover {        
        border: solid 1px ${(props: TCButtonProps) => (props.disabled?'transparent':(props.backgroudColor ?? '#4da0ff'))};
        cursor: ${(props: TCButtonProps) => (props.disabled ? 'none' : 'pointer')};
    }


   
`
